<template lang="pug">
  div.d-flex.gap-2
    legend-data(
      :legendTitle="shippingCosts.legendTitle" 
      :tooltipText="shippingCosts.tooltipText"
      :color="shippingCosts.color"
    )
    legend-data(
      :legendTitle="previousPrice.legendTitle" 
      :tooltipText="previousPrice.tooltipText"
      :color="previousPrice.color"
    )
    legend-data(
      :legendTitle="currentPrice.legendTitle" 
      :tooltipText="currentPrice.tooltipText"
      :color="currentPrice.color"
    )
    legend-data(
      :legendTitle="noData.legendTitle" 
      :tooltipText="noData.tooltipText"
      :color="noData.color"
    )
</template>

<script>
import LegendData from './LegendData.vue'

export default {
  name: "PromoPizzaLegend",
  data() {
    return {
      shippingCosts: {
        legendTitle: this.$gettext("Shipping costs"),
        tooltipText: this.$gettext("La información que se nos facilita corresponde a los gastos de envío de los agregadores."),
        color: "#00AFE5"
      },
      previousPrice: {
        legendTitle: this.$gettext("Previous price"),
        tooltipText: this.$gettext("La información proporcionada corresponde al precio anterior de los productos, de las dimensiones y los costos de envío."),
        color: "#F93549"
      },
      currentPrice: {
        legendTitle: this.$gettext("Current price"),
        tooltipText: this.$gettext("La información que se nos proporciona es el precio actual de los diferentes productos y tamaños."),
      },
      noData: {
        legendTitle: this.$gettext("N/D (no hay datos)"),
        tooltipText: this.$gettext("Aquí no hay datos disponibles, ya que la marca y el agregador no ofrecen actualmente este tamaño o producto."),
        color: "orange"
      }
    }
  },
  components: {
    LegendData
  }
}
</script>
